import { ArrowUpRight } from "lucide-react";
import Reveal from "../Reveal";

export const ServiceCard = ({ item, index, total, image }) => {
  const idx = String(index + 1).padStart(2, "0");
  const tot = String(total).padStart(2, "0");

  return (
    <Reveal
      delay={index * 40}
      className="card-flat overflow-hidden"
      data-testid={`service-${idx}`}
    >
      <div className="grid md:grid-cols-12 gap-0 items-stretch">
        <div className="md:col-span-5 relative aspect-[4/3] md:aspect-auto md:min-h-[420px] overflow-hidden bg-ink-100">
          <img
            src={image}
            alt={item.title}
            loading="lazy"
            className="w-full h-full object-cover img-mono"
          />
          <div className="absolute top-4 md:top-5 left-4 md:left-5 flex items-center gap-3">
            <span className="overline bg-white/80 backdrop-blur px-3 py-1 rounded-full">
              {item.tag}
            </span>
          </div>
        </div>
        <div className="md:col-span-7 p-6 md:p-12 lg:p-16 flex flex-col justify-between gap-8 md:gap-10">
          <div>
            <div className="flex items-baseline justify-between mb-4 md:mb-6">
              <span className="overline">{idx} / {tot}</span>
              <ArrowUpRight className="w-5 h-5 text-ink-300" strokeWidth={1.4} />
            </div>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[0.98] tracking-tightest">
              {item.title}
            </h2>
            <p className="mt-4 md:mt-6 text-[14px] md:text-[15px] text-ink-500 leading-relaxed max-w-xl">
              {item.desc}
            </p>
          </div>
          <ul className="grid grid-cols-2 gap-x-4 md:gap-x-6 gap-y-2 md:gap-y-3 pt-6 md:pt-8 border-t border-ink-200">
            {item.deliverables.map((d) => (
              <li key={d} className="flex items-start gap-2 md:gap-3">
                <span className="mt-2 w-1 h-1 rounded-full bg-ink-900 shrink-0" />
                <span className="text-[12px] md:text-[13px] text-ink-700">
                  {d}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Reveal>
  );
};
